var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "brand",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.634,
    height: 12.702,
    viewBox: "0 0 12.634 12.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55225",
    "data-name": "Group 55225",
    transform: "translate(1.241 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86254",
    "data-name": "Path 86254",
    d: "M199.888,169.143l-.468-.948-.468.948a.33.33,0,0,1-.249.181l-1.046.152.757.738a.33.33,0,0,1,.1.292l-.179,1.042.935-.492a.33.33,0,0,1,.307,0l.935.492-.179-1.042a.331.331,0,0,1,.1-.292l.757-.738-1.046-.152A.33.33,0,0,1,199.888,169.143Z",
    transform: "translate(-194.344 -164.75)",
    fill: "#86899b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86255",
    "data-name": "Path 86255",
    d: "M107.2,69.342a.428.428,0,0,1,0-.266l.268-.824a1.089,1.089,0,0,0-.4-1.22l-.7-.509a.428.428,0,0,1-.156-.215l-.268-.824a1.089,1.089,0,0,0-1.038-.754h-.866a.428.428,0,0,1-.253-.082l-.7-.509a1.089,1.089,0,0,0-1.283,0l-.7.509a.428.428,0,0,1-.253.082h-.866a1.089,1.089,0,0,0-1.038.754l-.268.824a.428.428,0,0,1-.156.215l-.7.509a1.089,1.089,0,0,0-.4,1.22l.268.824a.428.428,0,0,1,0,.266l-.268.824a1.089,1.089,0,0,0,.4,1.22l.7.509a.428.428,0,0,1,.156.215l.268.824a1.089,1.089,0,0,0,1.038.754h.866a.428.428,0,0,1,.253.082l.7.509a1.089,1.089,0,0,0,1.283,0l.7-.509a.428.428,0,0,1,.253-.082h.866a1.089,1.089,0,0,0,1.038-.754l.268-.824a.428.428,0,0,1,.156-.215l.7-.509a1.089,1.089,0,0,0,.4-1.22Zm-2.051-.683-1.112,1.084.262,1.53a.33.33,0,0,1-.479.348l-1.374-.723-1.374.723a.33.33,0,0,1-.479-.348l.262-1.53-1.112-1.084a.33.33,0,0,1,.183-.564l1.537-.223.687-1.392a.33.33,0,0,1,.593,0l.687,1.392,1.537.223a.33.33,0,0,1,.183.564Z",
    transform: "translate(-97.37 -63.927)",
    fill: "#86899b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55226",
    "data-name": "Group 55226",
    transform: "translate(7.646 8.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86256",
    "data-name": "Path 86256",
    d: "M296.111,312.751l-1.561-1.561-.342.248-.251.773a1.682,1.682,0,0,1-1.6,1.165h-.813l-.32.232,2.017,2.016a.331.331,0,0,0,.234.1.317.317,0,0,0,.068-.007.33.33,0,0,0,.24-.2l.624-1.6,1.6-.624a.33.33,0,0,0,.113-.541Z",
    transform: "translate(-291.22 -311.19)",
    fill: "#86899b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55227",
    "data-name": "Group 55227",
    transform: "translate(0 8.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86257",
    "data-name": "Path 86257",
    d: "M64.476,313.377h-.813a1.682,1.682,0,0,1-1.6-1.165l-.251-.773-.342-.248-1.561,1.561a.33.33,0,0,0,.113.541l1.6.624.624,1.6a.33.33,0,0,0,.24.2.317.317,0,0,0,.068.007.331.331,0,0,0,.234-.1l2.017-2.016Z",
    transform: "translate(-59.808 -311.19)",
    fill: "#86899b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand1);
export default __webpack_public_path__ + "static/media/brand_1.73e109584bb2ddf83344ec60fcadbec6.svg";
export { ForwardRef as ReactComponent };